import React from 'react';
import { Link } from 'wouter';

const SiteFooter = () => (
  <footer className="w-full border-t border-slate-200 bg-white/70 backdrop-blur-sm">
    <div className="mx-auto max-w-7xl px-4 py-3 text-center">
      <span className="text-[11px] leading-5 text-slate-500">©HiPo Career Solutions LLP</span>
      <div className="mt-2 flex justify-center items-center gap-4 text-[10px]">
        <Link href="/terms" className="text-slate-400 hover:text-slate-600 transition-colors">
          Terms of Service
        </Link>
        <span className="text-slate-300">•</span>
        <Link href="/privacy" className="text-slate-400 hover:text-slate-600 transition-colors">
          Privacy Policy
        </Link>
        <span className="text-slate-300">•</span>
        <Link href="/refund-policy" className="text-slate-400 hover:text-slate-600 transition-colors">
          Refund Policy
        </Link>
      </div>
    </div>
  </footer>
);

export default SiteFooter;
